<mat-dialog-content *ngIf="data" class="dialog-content">
  <app-contact-detail [currentContact]="data.kontakt" [showRelated]="data.showRelated"></app-contact-detail>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <pezi-button text="Schließen" [isPlain]="true" icon="close" [alignIconRight]="true" mat-dialog-close></pezi-button>
</mat-dialog-actions>



